import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config.service';

export interface ApiKey {
  id: number,
  apiKey: string,
  active: number,
  description: string
}


@Injectable({
  providedIn: 'root'
})
export class ApiKeyService {

  constructor(
   private http: HttpClient,
    private config: ConfigService,
  ) { }


  /**
   * Gets the legacy MCAPI key for the coldfusion/taffy api.  Ideally shouldn't be used very often, as we want to convert them to loopback.
   * @returns 
   */
  getLegacyMcStaffKey() {
    return this.http.get<ApiKey>(`${this.config.dataApiUrl}/staff/apiKey`)
  }
}
